import { useState, useEffect } from 'react';
import { getAll } from '../../../service/callcenter/SimChange';
import { useHistory } from 'react-router-dom';
import { SimChangeModel } from '../models/SimChange';

export const useGetAll = (realoadGrid: number, filters: any) => {
  const [data, setData] = useState<SimChangeModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(0);
  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      setLoadingRequest(0);
      const res = await getAll(filters)
        .then()
        .catch((error) => {
          history.push('/error/500');
        });
      if (res) {
        setData(res.rows);
        setLoadingRequest(1);
      }
    };
    if (realoadGrid) {
      fetchPost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realoadGrid]);
  return { data, loadingRequest };
};
